export default __webpack_public_path__ + "static/media/Mystic ocean_primary.84e16965.jpg";